// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.AbstractDataSource
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { AbstractClientRequestContext } from "abweb/dto/ds/AbstractClientRequestContext";
import { KendoObservableObjectProxy } from "abweb/dto/kendo/KendoObservableObjectProxy";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class AbstractDataSourceBase extends KendoObservableObjectProxy {
  /** Do NOT invoke directly, instead use strongly typed createAbstractDataSourceBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.AbstractDataSource";
  }
  initFromJson(json, deserializeContext) {
    this.initAbstractDataSource(json.argumentValues != null ? json.argumentValues : null, TSOGUtils.decodeObject(json.clientRequestContext, AbstractClientRequestContext, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "clientRequestContext")), json.id != null ? json.id : null);
  }
  initAbstractDataSource(argumentValues, clientRequestContext, id) {
    this.initKendoObservableObjectProxy();
    this._argumentValues = argumentValues;
    this._clientRequestContext = clientRequestContext;
    this._id = id;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._argumentValues != null) {
      retVal["argumentValues"] = this._argumentValues;
    }
    if (this._clientRequestContext != null) {
      retVal["clientRequestContext"] = TSOGUtils.toTSOGNativeObject(this._clientRequestContext, serializeContext);
    }
    if (this._id != null) {
      retVal["id"] = this._id;
    }
    return retVal;
  }
  get argumentValues() {
    return this._argumentValues;
  }
  set argumentValues(value) {
    this._argumentValues = value;
  }
  get clientRequestContext() {
    return this._clientRequestContext;
  }
  set clientRequestContext(value) {
    this._clientRequestContext = value;
  }
  get id() {
    return this._id;
  }
  set id(value) {
    this._id = value;
  }
}
//# sourceMappingURL=AbstractDataSourceBase.js.map
